import { PortalApps } from "../_models/portal-routes";

export const PortalAppRouteList: PortalApps[] = [
  {
    application: 'portal',
    displayName: 'Portal',
    baseUrl: 'Portal',
    enabled: true,
    routes: [
      {
        name: 'dataentry',
        displayName: 'Data Entry',
        subUrl: 'dataentry',
        enabled: false,
        icon: 'fas fa-table'
      },
      {
        name: 'bulkedit',
        displayName: 'Bulk Edit',
        subUrl: 'bulkedit',
        enabled: false,
        icon: 'fas fa-list-alt'
      },
      {
        name: 'reports',
        displayName: 'Reports',
        subUrl: 'reportlist',
        enabled: true,
        icon: 'fas fa-clipboard-list'
      },
      {
        name: 'dashboards',
        displayName: 'Dashboards',
        subUrl: 'dashboardlist',
        enabled: true,
        icon: 'far fa-chart-bar'
      },
      {
        name: 'wellfiles',
        displayName: 'Well Files',
        subUrl: 'wellfiles',
        enabled: true,
        icon: 'fas fa-file-alt'
      }
    ]
  },
  {
    application: 'controlPanel',
    displayName: 'Control Panel',
    baseUrl: 'ControlPanel',
    enabled: false,
    routes: [
      {
        name: 'myProfile',
        displayName: 'My Profile',
        subUrl: 'users/user',
        enabled: false,
        icon: 'fas fa-user'
      },
      {
        name: 'users',
        displayName: 'Users',
        subUrl: 'users',
        enabled: false,
        icon: 'fas fa-users'
      },
      {
        name: 'wells',
        displayName: 'Wells',
        subUrl: 'wells',
        enabled: false,
        icon: 'fas fa-tint'
      }
    ]
  }
] 
